var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#461E7D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7465 24C11.1512 24 10.667 23.48 10.667 22.8418V11.44C10.667 10.8009 11.1512 10.2818 11.7465 10.2818H13.8251V9.15733C13.8251 8.51911 14.3102 8 14.9055 8H17.0512C17.6474 8 18.1316 8.51911 18.1316 9.15733L14.9055 9.15467L14.9038 10.8596C14.9038 11.1787 14.6625 11.4373 14.3657 11.4373H11.7465L11.7449 22.8418L20.2541 22.8436L20.2558 11.44L16.4327 11.4373L15.8789 14.2187H17.591C17.7659 14.2187 17.9293 14.3102 18.0313 14.4631C18.1316 14.616 18.1573 14.8124 18.0976 14.9893L16.6433 19.3804L15.6276 18.9929L16.8282 15.3724H15.2122C15.0497 15.3724 14.8955 15.2942 14.7935 15.1591C14.6916 15.024 14.6518 14.8453 14.6858 14.6756L15.4701 10.7378C15.5232 10.4711 15.7429 10.2809 15.9966 10.2809H20.255C20.8495 10.2809 21.3337 10.8 21.3337 11.4391V22.8409C21.3328 23.48 20.8486 24 20.2541 24H11.7465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteria);
export default __webpack_public_path__ + "static/media/batteria.c5691ca7fa8666ac62791d3afc2668b5.svg";
export { ForwardRef as ReactComponent };